export const initialState = {
  version: '1.0.0',
}
